import { clsx } from 'clsx';
import * as React from 'react';
export default function CloseBtn(props) {
  const {
    prefixCls,
    icon,
    onClick,
    className,
    style
  } = props;
  return /*#__PURE__*/React.createElement("button", {
    className: clsx(`${prefixCls}-close`, className),
    style: style,
    onClick: onClick
  }, icon);
}